module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_favorite_remove-c0e799b364ff24781ef3acbf9c81bd33.svg";